import { Carousel2 } from '@intigral/ui/components/Carousel2';
import f from '../../../helpers/formatter';
import { __ } from '../../../translations';
import { SectionHeaderWithPagination } from '@intigral/ui/components/SectionHeaderWithPagination';
import { IAddonsCarouselProps } from '../types/iAddonsCarousel';
import { AddonRegularItem, AddonStaticItem } from './elements';
import { useAddonItem } from '../hooks/useAddonItem';
import { getManageAddonsLink } from '../utils/addonsUtils';
import mixpanel from 'mixpanel-browser';
import user from '../../../helpers/user';

const AddonCarousel: React.FC<IAddonsCarouselProps> = ({ content, meta, carousel }) => {
    const { carouselContent, configuration, language, operator } = useAddonItem(content);

    if (!carouselContent?.length) return null;

    return (
        <div
            className="container full-width"
            style={{ overflowX: 'hidden' }}
            id={carousel?.id}
            data-test-id={carousel?.id}
        >
            <SectionHeaderWithPagination
                title={f.getComponentTitle(meta)}
                className="paging"
                onClick={() => {
                    const isPickAndChoose =
                        configuration?.pickAndChoose?.enable &&
                        configuration?.pickAndChoose?.allowedOperators?.includes(operator);
                    const isBundleAndSave = user.isBundleAndSaveEnabled(operator);
                    const ctaName = 'manage addons';
                    const offerName = isPickAndChoose
                        ? 'Pick and Choose'
                        : isBundleAndSave
                          ? 'Bundle and Save'
                          : 'None';
                    mixpanel.track('Manage Add-on Click', {
                        'Offer name': offerName,
                        'Screen name': 'Home Page',
                        'CTA Name': ctaName,
                    });
                }}
                seeAllUrl={getManageAddonsLink(configuration, language, operator)}
                seeAllText={__('manage_addons_link')}
                manageAddons={true}
            />
            <Carousel2
                swiperSettings={{
                    autoplay: false,
                    slidesPerView: 1.5,
                    slidesPerGroup: '1',
                    breakpoints: {
                        '560': {
                            slidesPerView: 2,
                        },
                        '740': {
                            slidesPerView: 2.5,
                        },
                        '924': {
                            slidesPerView: 3,
                        },
                        '1024': {
                            slidesPerView: 3.5,
                        },
                        '1212': {
                            slidesPerView: 5,
                        },
                        '1500': {
                            slidesPerView: 5,
                        },
                    },
                    loop: false,
                    pagination: {
                        clickable: true,
                        el: '.paging',
                    },
                }}
                dir={language === 'ar' ? 'rtl' : 'ltr'}
            >
                {carouselContent.map((item, index) => {
                    const itemKey = `${item.subscriptionGuid ?? item.planName ?? item.bannerName ?? 'addon'}-${index}`;

                    if (item.isStatic) {
                        return <AddonStaticItem key={itemKey} item={item} index={index} carousel={carousel} />;
                    }

                    return (
                        <AddonRegularItem
                            key={itemKey}
                            item={item}
                            index={index}
                            config={configuration}
                            carousel={carousel}
                        />
                    );
                })}
            </Carousel2>
        </div>
    );
};

export default AddonCarousel;
